module.exports = __webpack_public_path__ + "static/media/banner-doctor.dca5c280.png";